import UserCodes from './UserCodes';

export default UserCodes;